import { useSelector } from 'react-redux';
import { ICatalogItemState, catalogItemSelector } from './store';

export const useCatalogItem = (): Partial<ICatalogItemState> => {
  const catalogItem = useSelector(catalogItemSelector);
  return { ...catalogItem };
};
